import { HistoryUpdatesItemType } from 'src/components/History/types';

export const historyUpdates: HistoryUpdatesItemType[] = [
    { key: 'webhookId', translateKey: 'webhookHistory.webhookId', format: 'number' },
    { key: 'WEBHOOK_TYPE', translateKey: 'webhookDetail.webhookType' },
    { key: 'METHOD', translateKey: 'webhookDetail.method' },
    { key: 'ACTIVE', translateKey: 'webhookDetail.active' },
    { key: 'URL', translateKey: 'webhookDetail.url' },
    { key: 'PARAMETERS', translateKey: 'webhookDetail.parameters' },
    { key: 'REGISTERED_AT', translateKey: 'webhookDetail.registeredAt', format: 'date' },
    { key: 'UNREGISTERED_AT', translateKey: 'webhookDetail.unregisteredAt', format: 'date' },
    { key: 'DEACTIVATION_EMAIL_SENT_AT', translateKey: 'webhookDetail.deactivationEmailSentAt', format: 'date' },
    { key: 'SECRET_REGENERATED', translateKey: 'webhookDetail.secretRegenerated' },
];
